import { api } from '@/shared/api/client';
import type { Schema } from '@/shared/api/contract';

export type Elevation = Schema<'ElevationRead'>;

/**
 * The elevated mode (contract v10): the administrator retypes the password and the
 * session may create users, register mailboxes and change the triage settings for five
 * minutes. In `shared/` because more than one feature guards its writes with it.
 */
export const elevationApi = {
  elevate: (password: string): Promise<Elevation> =>
    api.post<Elevation>('/api/auth/elevate', { password }),
  current: (): Promise<Elevation> => api.get<Elevation>('/api/auth/elevation'),
};
